import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useStore } from "../context/StoreContext";
import { t } from "../lib/i18n";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { lang, login } = useStore();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      login(data.token, data.user);
      toast.success(lang === "ar" ? "مرحباً بك" : "Welcome back");
      navigate(data.user.role === "admin" ? "/admin" : "/");
    } catch (err) {
      toast.error(err.response?.data?.detail || (lang === "ar" ? "خطأ في تسجيل الدخول" : "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <div className="bg-white border border-[#e8ddc9] rounded-2xl p-8">
        <h1 className={`${lang === "ar" ? "font-arabic-heading" : "font-english-heading"} text-3xl font-semibold mb-6 text-center`} style={{ color: "var(--thiqa-primary)" }}>
          {t(lang, "login")}
        </h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>{t(lang, "email")}</Label>
            <Input data-testid="login-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <Label>{t(lang, "password")}</Label>
            <Input data-testid="login-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <Button data-testid="login-submit" disabled={loading} type="submit" className="w-full btn-primary-thiqa rounded-full py-6">
            {loading ? "…" : t(lang, "login")}
          </Button>
        </form>
        <p className="text-sm text-center mt-4 text-gray-600">
          {lang === "ar" ? "لا تملك حساباً؟" : "No account?"}{" "}
          <Link to="/register" className="text-[color:var(--thiqa-primary)] font-semibold">{t(lang, "register")}</Link>
        </p>
      </div>
    </div>
  );
}
